export type DisplayedLogoFetchedPayload = {
	dataUrl: string | null;
};

export type DisplayedLogoFetchedAction = {
	type: 'DISPLAYED_LOGO_FETCHED';
	payload: DisplayedLogoFetchedPayload;
	organizationId: number;
};

export default (
	payload: DisplayedLogoFetchedPayload,
	organizationId: number,
): DisplayedLogoFetchedAction => ({
	type: 'DISPLAYED_LOGO_FETCHED',
	payload,
	organizationId,
});
